import React, {useState} from 'react'

function SaveTransaction() {
    const [montant, setMontant] = useState('');
      const [service, setService] = useState('');
      const [erreur, setErreur] = useState(null);
    
      const enregistrerTransaction = (e) => {
        e.preventDefault();
        // Enregistrer la transaction
        if (montant === '' || service === '') {
          setErreur('Veuillez entrer le montant et le service');
        } else {
          // Simuler l'enregistrement de la transaction
          const transactionEnregistree = true;
          if (transactionEnregistree) {
            setErreur(null);
            alert('La transaction a été enregistrée avec succès');
          } else {
            setErreur('Erreur lors de l\'enregistrement de la transaction');
          }
        }
      };

  return (
    <div className="enregistrer-transaction">
      <h2>Enregistrer une transaction</h2>
      <form onSubmit={enregistrerTransaction}>
        <label>
          Montant :
          <input
            type="number"
            value={montant}
            onChange={(e) => setMontant(e.target.value)}
          />
        </label>
        <label>
          Service :
          <input
            type="text"
            value={service}
            onChange={(e) => setService(e.target.value)}
          />
        </label>
        {erreur && <p style={{ color: 'red' }}>{erreur}</p>}
        <button type="submit">Enregistrer</button>
      </form>
    </div>
  )
}

export default SaveTransaction